import { render, staticRenderFns } from "./watchlist_tick.vue?vue&type=template&id=04bcf814&scoped=true"
import script from "./watchlist_tick.vue?vue&type=script&lang=js"
export * from "./watchlist_tick.vue?vue&type=script&lang=js"
import style0 from "./watchlist_tick.vue?vue&type=style&index=0&id=04bcf814&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bcf814",
  null
  
)

export default component.exports